import { Suspense, lazy, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer/Footer";
import { useParams } from "react-router-dom";
import { handleRedirectPortal, verificarLeadCadastrado } from "./api/simulador";
import FirstBlock from "../components/lp/FirstBlock";
import { FormProvider } from "../context/FormContext";

const MenuMiddle = lazy(() => import("../components/lp/MenuMiddle"));
const BenefitsBlock = lazy(() =>
  import("../components/lp/BenefitsBlock")
);
const RegisterBlock = lazy(() =>
  import("../components/lp/RegisterBlock")
);
const RzkBlock = lazy(() => import("../components/lp/rzkBlock"));
const FaqBlock = lazy(() => import("../components/lp/faqBlock"));

const Main = () => {
  const { token: tokenParam } = useParams();
  const tokenFromQuery = new URLSearchParams(window.location.search).get("token");
  const tokenClaro = tokenParam || tokenFromQuery || "";

  useEffect(()=>{
    verificarLeadCadastrado(tokenClaro)
    .then(res => {
      if(res){
        handleRedirectPortal(res)
      }
    }).catch(err => {
      console.error(err)
    })
  }, [] )
  
  return (
    <FormProvider>
    <div className="overflow-hidden">
      <Header />
      <FirstBlock />
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <MenuMiddle />
      </Suspense>
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <BenefitsBlock />
      </Suspense>
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <RegisterBlock />
      </Suspense>
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <RzkBlock />
      </Suspense>
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <FaqBlock />
      </Suspense>
      <div className="w-full bg-claro-red h-28" />
      <Suspense
        fallback={<div className="text-center p-8">Carregando seção...</div>}
      >
        <Footer />
      </Suspense>
      {/* <FloatingWhatsApp /> */}
    </div>
    </FormProvider>
  );
};

export default Main;
